<template>
    <div
        class="editorQrCodeElement"
        style="width: 100%; height: 100%;"
        :id="`editorQrCodeElement-${el.id}`"
    >
        <img :src="qrPlaceholder" />
    </div>
</template>

<script>
    import qrPlaceholder from '@/assets/img/qrPlaceholder.png';
    export default {
        data() {
            return {
                qrPlaceholder
            }
        },
        props: ['el']
    }
</script>

<style lang="scss" scoped>
    .editorQrCodeElement {
        img {
            width: 100%;
            height: 100%;
        }
    }
</style>